module.exports = __webpack_public_path__ + "img/video-1.d2510b72.jpg";